import { render } from "./ReturnButton.vue?vue&type=template&id=2941add8"
import script from "./ReturnButton.vue?vue&type=script&lang=js"
export * from "./ReturnButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__